(function (global) {
  const G =
    '<svg class="grw-g" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>';

  function esc(value) {
    return String(value ?? '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function stars(count) {
    const n = Math.max(0, Math.min(5, Number(count) || 0));
    const full = '★★★★★'.slice(0, n);
    const empty = '★★★★★'.slice(n);
    return `<span class="grw-stars" aria-label="${n} out of 5"><span>${full}</span><span class="grw-stars__empty">${empty}</span></span>`;
  }

  function cardHtml(review) {
    const author = esc(review.author || 'Google user');
    const initial = esc((review.author || 'G').trim().charAt(0).toUpperCase());
    const when = review.when ? `<small class="grw-when">${esc(review.when)}</small>` : '';
    return `<article class="grw-card">
      <div class="grw-card__top">${stars(review.rating ?? 5)}${G}</div>
      <p class="grw-card__text">${esc(review.text || '')}</p>
      <footer class="grw-card__foot">
        <span class="grw-avatar" aria-hidden="true">${initial}</span>
        <span><strong class="grw-author">${author}</strong>${when}</span>
      </footer>
    </article>`;
  }

  function render(root, data) {
    const biz = data.business || {};
    const reviews = Array.isArray(data.reviews) ? data.reviews : [];
    const name = esc(biz.name || 'Google reviews');
    const rating = biz.rating != null ? esc(biz.rating) : '';
    const count = biz.reviewCount != null ? esc(biz.reviewCount) : '';
    const url = esc(biz.url || '#');
    const logo = biz.logo
      ? `<img class="grw-logo" src="${esc(biz.logo)}" alt="">`
      : `<span class="grw-logo" aria-hidden="true">${esc(name.charAt(0))}</span>`;
    const prev = esc(data.labels?.prev || 'Previous reviews');
    const next = esc(data.labels?.next || 'Next reviews');
    const all = esc(data.labels?.all || 'See all Google reviews');

    root.innerHTML = `
      <div class="grw-bar">
        <div class="grw-business">
          ${logo}
          <div>
            <strong>${name}</strong>
            <div class="grw-meta">${stars(biz.rating || 5)}${rating ? `<span>${rating}</span>` : ''}${count ? `<span>${count} reviews</span>` : ''}</div>
          </div>
        </div>
        <div class="grw-nav">
          <button type="button" class="grw-arrow" data-grw-prev aria-label="${prev}">‹</button>
          <button type="button" class="grw-arrow" data-grw-next aria-label="${next}">›</button>
        </div>
      </div>
      <div class="grw-viewport">
        <div class="grw-track">${reviews.map(cardHtml).join('')}</div>
      </div>
      <a class="grw-all" href="${url}" target="_blank" rel="noopener noreferrer">${all} →</a>
    `;
  }

  function perView(width) {
    if (width < 560) return 1;
    if (width < 900) return 2;
    return 3;
  }

  function bind(root) {
    const viewport = root.querySelector('.grw-viewport');
    const track = root.querySelector('.grw-track');
    const cards = [...root.querySelectorAll('.grw-card')];
    const prev = root.querySelector('[data-grw-prev]');
    const next = root.querySelector('[data-grw-next]');
    if (!viewport || !track || !cards.length) return;

    let index = 0;
    let timer = 0;
    let startX = 0;
    let dragging = false;

    function layout() {
      const view = perView(viewport.clientWidth);
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      const width = (viewport.clientWidth - gap * (view - 1)) / view;
      cards.forEach((card) => {
        card.style.flexBasis = `${width}px`;
        card.style.width = `${width}px`;
      });
      return { view, gap, width };
    }

    function maxIndex() {
      return Math.max(0, cards.length - perView(viewport.clientWidth));
    }

    function paint(animate) {
      if (!viewport.clientWidth) {
        window.requestAnimationFrame(() => paint(animate));
        return;
      }
      const { width, gap } = layout();
      const max = maxIndex();
      if (index > max) index = max;
      if (index < 0) index = 0;
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = `translate3d(${-index * (width + gap)}px,0,0)`;
      if (prev) prev.disabled = cards.length <= perView(viewport.clientWidth);
      if (next) next.disabled = cards.length <= perView(viewport.clientWidth);
    }

    function go(dir) {
      const max = maxIndex();
      if (!max) return;
      index += dir;
      if (index > max) index = 0;
      if (index < 0) index = max;
      paint();
    }

    function stop() {
      window.clearInterval(timer);
      timer = 0;
    }

    function start() {
      stop();
      const ms = Number(root.getAttribute('data-autoplay') || 0);
      if (ms > 0 && maxIndex() > 0) timer = window.setInterval(() => go(1), ms);
    }

    prev?.addEventListener('click', () => { go(-1); start(); });
    next?.addEventListener('click', () => { go(1); start(); });

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      startX = event.clientX;
      stop();
    });
    viewport.addEventListener('pointerup', (event) => {
      if (!dragging) return;
      dragging = false;
      const dx = event.clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      start();
    });
    viewport.addEventListener('pointerleave', () => { dragging = false; });
    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    if (window.ResizeObserver) new ResizeObserver(() => paint(false)).observe(viewport);
    else window.addEventListener('resize', () => paint(false));
    window.requestAnimationFrame(() => paint(false));
    start();
  }

  function mount(root, data) {
    if (!root || root.dataset.grwReady) return;
    const json = root.querySelector(':scope > script[type="application/json"]');
    let payload = data;
    if (!payload && json) {
      try { payload = JSON.parse(json.textContent); } catch (err) { payload = null; }
    }
    if (payload && !root.querySelector('.grw-card')) render(root, payload);
    root.dataset.grwReady = 'true';
    bind(root);
  }

  function auto() {
    document.querySelectorAll('[data-grw]').forEach((el) => {
      const json = el.querySelector(':scope > script[type="application/json"]');
      const hasSrc = json && json.hasAttribute('src');
      const hasCards = el.querySelector('.grw-card');
      const hasInline = json && !hasSrc && json.textContent.trim();
      if (hasCards || hasInline) mount(el);
    });
  }

  global.GoogleReviewsWidget = { mount, auto };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();
})(typeof window !== 'undefined' ? window : this);
